import React from 'react';
import { useHistory } from 'react-router-dom';
import useParamsRoute from '@profile/src/hooks/useRouteParams';
import { TooltipProvider } from '@profile/src/Components/TooltipProvider';
import NavBar from './Components/NavBar';
import UserWalletProvider from './UserWalletProvider';
import { menuList } from './config';
import styles from './styles.module.scss';
import ClaimBoxProvider from './Components/Inventory/ThetanBoxTab/WalletProvider';
import { TooltipProvider as TooltipProviderV2 } from '@profile/src/Components/TooltipProviderV2';

const ProfileContainer = () => {
  const history = useHistory();
  const params = useParamsRoute();
  const selectedMenu = menuList.find(e => e.key === params.tab) || menuList[0];
  const selectedCategory = params.category;

  const onMenuChange = (menu, category) => {
    history.push({
      search: `tab=${menu.key}${category ? `&category=${category}` : ''}`
    });
  };

  const Content = selectedMenu.Component;
  return /*#__PURE__*/React.createElement(UserWalletProvider, {
    showWarning: true
  }, /*#__PURE__*/React.createElement(TooltipProviderV2, null, /*#__PURE__*/React.createElement("div", {
    className: styles.root
  }, /*#__PURE__*/React.createElement(NavBar, {
    selectedMenu: selectedMenu,
    selectedCategory: selectedCategory,
    onMenuChange: onMenuChange,
    className: styles.navBar
  }), /*#__PURE__*/React.createElement("div", {
    className: styles.content
  }, /*#__PURE__*/React.createElement(Content, null)))));
};

const ProfilePage = () => {
  return /*#__PURE__*/React.createElement(TooltipProvider, null, /*#__PURE__*/React.createElement(ClaimBoxProvider, null, /*#__PURE__*/React.createElement(ProfileContainer, null)));
};

export default ProfilePage;